import { TInstrumentsTable } from '@src/types/instruments.ts';

export const instrumentData: TInstrumentsTable[] = [
  // DxFeed instruments - Commented out
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
  // {
  //   category: 'Account Activated (dxFeed)',
  //   exchange: 'CBOT',
  //   name: 'Corn',
  //   symol: 'ZC',
  //   tickSize: '0.25',
  //   pointValue: '$ 50',
  // },
];
